import { LiveDot } from '@/components/MomentStyle'
import { toldWhen, type ToldFields } from '@/lib/moments'
import { cn } from '@/lib/utils'

// The small label a moment wears: the live dot and "Now · Tonight", or its date. On a photo it sits on a pill.
export function ToldLabel({
  moment,
  onPhoto,
  className,
}: {
  moment: ToldFields
  onPhoto?: boolean
  className?: string
}) {
  const { live, text } = toldWhen(moment)
  if (!text) return null
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap',
        !live && !onPhoto && 'text-muted-foreground',
        onPhoto && 'rounded-full bg-white/92 px-2.5 py-1 text-viewer shadow-md',
        className,
      )}
    >
      {live && <LiveDot />}
      <span className="truncate">{text}</span>
    </span>
  )
}
